var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThird(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.884 6C81.326 20.6986 102.768 20.0156 102.768 20.0156V44.1061C102.768 73.2143 86.6536 99.9188 60.9075 113.461L59.884 114L58.8604 113.461C33.1142 99.9188 17 73.2143 17 44.1061V20.0024C17 20.0024 38.442 20.6855 59.884 6Z",
    fill: "#82B5A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6192 98.1051L59.8844 98.486L59.1495 98.1051C40.7913 88.4505 29.2961 69.404 29.2961 48.65V31.4688C27.9051 31.5476 27.1309 36.2369 27.1309 36.2369V53.4182C27.1309 74.1722 40.5551 91.0645 58.9133 100.719C58.9133 100.719 72.5869 98.4992 84.1739 74.4087C79.0168 84.3522 73.0724 91.7475 60.6192 98.1051Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.884 6C38.442 20.6986 17 20.0156 17 20.0156V23.3783C23.0757 23.1024 42.3656 21.7495 59.6346 9.91438C81.0766 24.613 100.472 23.4177 100.472 23.4177V47.5081C100.472 62.6665 96.0886 77.1812 88.2546 89.5154C97.519 76.485 102.755 60.683 102.755 44.0929V20.0024C102.768 20.0024 81.326 20.6855 59.884 6Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.884 6C81.3259 20.6986 102.768 20.0156 102.768 20.0156V44.1061C102.768 73.2143 86.6536 99.9188 60.9075 113.461L59.884 114L58.8604 113.461C33.1142 99.9188 17 73.2143 17 44.1061V20.0024C17 20.0024 38.442 20.6855 59.884 6Z",
    stroke: "#282750",
    strokeWidth: 0.976828,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9658 16.9199C43.0415 28.6198 26.1172 28.0773 26.1172 28.0773V47.2545C26.1172 70.4197 38.8431 91.6788 59.1668 102.455L59.9803 102.88L60.7939 102.455C81.1176 91.6788 93.8435 70.4197 93.8435 47.2545V28.0773C93.8144 28.0773 76.8901 28.6198 59.9658 16.9199Z",
    fill: "white",
    stroke: "#282750",
    strokeWidth: 0.976828,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8838 16.1931V6",
    stroke: "#282750",
    strokeWidth: 0.976828,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4225 29.2931L19.5469 22.1035",
    stroke: "#282750",
    strokeWidth: 0.976828,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.768 20.8047L97.0205 25.7042",
    stroke: "#282750",
    strokeWidth: 0.976828,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1301 50.1501V44.5146C54.1301 41.0621 56.4793 38.2503 59.3623 38.2503C62.2453 38.2503 64.6063 41.0621 64.6063 44.5146V50.1501H72.9112V44.5146C72.9112 36.4825 66.8367 29.9453 59.3623 29.9453C51.8997 29.9453 45.8252 36.4825 45.8252 44.5146V50.1501H54.1301Z",
    stroke: "#282750",
    strokeWidth: 0.976828,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9716 76.833H44.7857C42.3891 76.833 40.4434 74.8873 40.4434 72.4907V54.4927C40.4434 52.0961 42.3891 50.1504 44.7857 50.1504H73.9716C76.3682 50.1504 78.314 52.0961 78.314 54.4927V72.4907C78.3021 74.8873 76.3682 76.833 73.9716 76.833Z",
    stroke: "#282750",
    strokeWidth: 0.976828,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7822 61.0517C55.7822 59.0704 57.3839 57.4688 59.3652 57.4688C61.3465 57.4688 62.9482 59.0704 62.9482 61.0517C62.9482 64.4805 61.1567 64.8127 61.1567 67.6957C61.1567 68.6923 60.35 69.4991 59.3534 69.4991C58.3568 69.4991 57.55 68.6923 57.55 67.6957C57.5737 64.9907 55.7822 63.6381 55.7822 61.0517Z",
    stroke: "#282750",
    strokeWidth: 0.976828,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThird);
export default __webpack_public_path__ + "static/media/third.7d8a210b54e4972b4d128c5e4a1d2a8c.svg";
export { ForwardRef as ReactComponent };